export const coreComponentName = "SdbSearchBar";
export const SEARCH_WRAPPER_CLOSED_WIDTH = 80;
